import styled from 'styled-components'

export const Container = styled.div`
  flex: 1;
  padding: 10px;
  background-color: ${({ theme }) => theme.colors.background};
  overflow-y: auto;
`
